/*
 * Copyright (c) 2026 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {PegParameterDefinition, PegParameterLabel, PegParameterWrite} from '@ion/core/src/types/entities';

export const WAKE_SLEEP_MODULE_TYPE = 'core';

export enum WizardStep {
  SCRIPT_DETAILS = 0,
  WAKE_SLEEP = 1,
  MODULES = 2,
  REVIEW = 3,
  GENERATE = 4
};

export enum ParameterType {
  NUM = 'num',
  BOOL = 'bool',
  STR = 'str',
  LIST = 'list'
};

export interface PegFieldProps {
  label: string;
  unit?: string;
  tooltip?: string;
  value: number | boolean | string;
  onChange?: (value: number | boolean | string) => void;
  disabled?: boolean;
  min?: number;
  max?: number;
  defaultValue: number | boolean | string;
};

export interface ComposedParameter {
  key: string;
  Component?: React.ComponentType<PegFieldProps>;
  definition?: PegParameterDefinition;
  label: string;
  unit?: string;
  tooltip: string;
  defaultValue: number | boolean | string;
  min?: number;
  max?: number;
};

export interface ComposedListOption {
  key: string;
  label: string;
  defaultValue: number | boolean | string;
  definition?: PegParameterDefinition;
};

export interface ComposedParameterGroup {
  key: string;
  header: string;
  subHeading?: string;
  type?: string;
  command?: string;
  listOptions?: ComposedListOption[];
  parameters: ComposedParameter[];
};

export interface PegDropdownFieldProps {
  label: string;
  value: string;
  options: {label: string; value: string}[];
  onChange: (value: string) => void;
  tooltip?: string;
  disabled?: boolean;
};

export type ParameterLabelWithDefault = PegParameterLabel & {
  defaultValue?: number | boolean | string;
};

export type WakeSleepValues = Record<string, Record<string, PegParameterWrite[]>>;

export type WakeSleepFlatValues = Record<string, number | boolean | string>;

export type StepVisited = Record<WizardStep, boolean>;

export type CompletedSteps = Record<WizardStep, boolean>;
